export const isoLocal = (data: Date) =>
  `${data.getFullYear()}-${String(data.getMonth() + 1).padStart(2, "0")}-${String(data.getDate()).padStart(2, "0")}`;

const deIso = (iso: string) => {
  const [ano, mes, dia] = iso.split("-").map(Number);
  return new Date(ano, mes - 1, dia);
};

const somaDias = (iso: string, dias: number) => {
  const data = deIso(iso);
  data.setDate(data.getDate() + dias);
  return isoLocal(data);
};

const DOMINGO = 0;
const SABADO = 6;

export const ultimoDiaUtil = (hoje: Date) => {
  const dia = new Date(hoje.getFullYear(), hoje.getMonth(), hoje.getDate() - 1);
  while (dia.getDay() === DOMINGO || dia.getDay() === SABADO) {
    dia.setDate(dia.getDate() - 1);
  }
  return isoLocal(dia);
};

export const MAX_DIAS_PERIODO = 31;

export const diasNoPeriodo = (inicio: string, fim: string) =>
  Math.round((deIso(fim).getTime() - deIso(inicio).getTime()) / 86400000) + 1;

export const inicioMinimo = (fim: string, maxDias = MAX_DIAS_PERIODO) => somaDias(fim, 1 - maxDias);

export const fimMaximo = (inicio: string, maxDias = MAX_DIAS_PERIODO) => somaDias(inicio, maxDias - 1);

export const segundaDaSemana = (iso: string) =>
  somaDias(iso, -((deIso(iso).getDay() + 6) % 7));

export const domingoDaSemana = (iso: string) =>
  somaDias(segundaDaSemana(iso), 6);

const diaMes = (iso: string) => `${iso.slice(8, 10)}/${iso.slice(5, 7)}`;

export const rotuloPeriodo = (inicio: string, fim: string) =>
  `${diaMes(inicio)} a ${diaMes(fim)}/${fim.slice(0, 4)}`;

export const rotuloSemana = (iso: string) =>
  rotuloPeriodo(segundaDaSemana(iso), domingoDaSemana(iso));
